import { omitBy, isNil } from 'lodash/fp'
import api from '@/services/api'

const RESOURCE_URI = '/checkout'

const fetchCheckouts = ({ storeId, date, fromDate, toDate } = {}) => {
  const query = new URLSearchParams(
    omitBy(isNil, { storeId, date, fromDate, toDate })
  ).toString()

  return api.get([RESOURCE_URI, query].join('?'))
}

const fetchCheckoutById = ({ id }) => api.get(`${RESOURCE_URI}/${id}`)

const fetchOpeningContext = ({ storeId }) =>
  api.get(`${RESOURCE_URI}/opening-context/${storeId}`)

const openCheckout = ({ checkoutId, storeId, ...checkout }) => {
  return api.post(`${RESOURCE_URI}/${checkoutId}/${storeId}/open`, checkout)
}

const checkoutToFormData = (checkout) => {
  const formData = new FormData()

  Object.entries(checkout).forEach(([key, value]) => {
    if (key === 'closingNotebookPhotos' || key === 'machineReceiptPhotos') {
      ;(value || []).forEach((file) => formData.append(key, file))
      return
    }

    if (
      key === 'closingNotebookDescriptions' ||
      key === 'machineReceiptDescriptions'
    ) {
      formData.append(key, JSON.stringify(value || []))
      return
    }

    if (value !== null && typeof value !== 'undefined') {
      formData.append(key, value)
    }
  })

  return formData
}

const closeCheckout = ({ ...checkout }) => {
  if (
    checkout.closingNotebookPhotos?.length ||
    checkout.machineReceiptPhotos?.length
  ) {
    return api.post(
      `${RESOURCE_URI}/${checkout.id}/close`,
      checkoutToFormData(checkout),
      {
        headers: { 'Content-Type': 'multipart/form-data' }
      }
    )
  }

  return api.post(`${RESOURCE_URI}/${checkout.id}/close`, checkout)
}

const fetchCheckoutReport = ({ id }) => api.get(`${RESOURCE_URI}/${id}/report`)

const fetchCheckoutPhotos = ({
  checkoutId,
  storeId,
  fromDate,
  toDate,
  type
} = {}) => {
  const query = new URLSearchParams(
    omitBy(isNil, { checkoutId, storeId, fromDate, toDate, type })
  ).toString()

  return api.get([`${RESOURCE_URI}/photos`, query].join('?'))
}

const addCheckoutPhoto = ({ checkoutId, type, photo, description }) => {
  const formData = new FormData()
  formData.append('type', type)
  formData.append('photo', photo)
  if (description) {
    formData.append('description', description)
  }

  return api.post(`${RESOURCE_URI}/${checkoutId}/photos`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

const deleteCheckoutPhoto = (photoId) =>
  api.delete(`${RESOURCE_URI}/photos/${photoId}`)

export default {
  fetchCheckouts,
  fetchCheckoutById,
  fetchOpeningContext,
  openCheckout,
  closeCheckout,
  fetchCheckoutReport,
  fetchCheckoutPhotos,
  addCheckoutPhoto,
  deleteCheckoutPhoto
}
